import React from 'react';

const NotFoundPage = () => (
  <>
    <h1>NotFoundPage</h1>
  </>
);

export default NotFoundPage;
